var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoommates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.677,
    height: 120.005,
    viewBox: "0 0 113.677 120.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 9.454,
    cy: 9.455,
    rx: 9.454,
    ry: 9.455,
    transform: "translate(29.492 29.863) rotate(-72.554)",
    fill: "#ffe89b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13088",
    "data-name": "Path 13088",
    d: "M82.235,81.238c-3.476-1.152-8.74.359-11.344,6.193a34.305,34.305,0,0,1,7.5-3.044,4.352,4.352,0,0,1,.989-.116,4.2,4.2,0,0,1,.959,8.3l-.063.016c-.066.018-.191.053-.36.1-.325.1-.855.268-1.545.533A31.543,31.543,0,0,0,73.022,95.9a32.414,32.414,0,0,0-6.046,4.872,58.692,58.692,0,0,0-.309,9.912c.441,3.78,2.033,5.79,4.016,6.874-.729,5.556-3.39,16.312-13.018,30.385a5.254,5.254,0,1,0,8.669,5.94c13.011-18.964,14.946-33.452,15.115-38.99.067-.578.108-1.236.12-1.987,1.256-3.411,2.18-6.2,2.863-8.51.453,1.318.855,2.677,1.2,4.078a50.4,50.4,0,0,0,2.62-4.317c.095-5.421-1.455-16.482-3.12-19.552A5.213,5.213,0,0,0,82.235,81.238Z",
    transform: "translate(-32.894 -46.884)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13089",
    "data-name": "Path 13089",
    d: "M73.432,98.268c.692-.265,1.242-.445,1.6-.553.181-.055.314-.092.395-.113l.079-.021a3.362,3.362,0,0,0-1.538-6.546h0a34.82,34.82,0,0,0-9.6,4.289,39.537,39.537,0,0,0-15.346,17.762,3.363,3.363,0,1,0,6.156,2.713,32.775,32.775,0,0,1,12.754-14.771A32.361,32.361,0,0,1,73.432,98.268Z",
    transform: "translate(-28.254 -52.719)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 9.455,
    cy: 9.454,
    rx: 9.455,
    ry: 9.454,
    transform: "translate(60.471 17.494) rotate(-17.451)",
    fill: "#ffe89b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13090",
    "data-name": "Path 13090",
    d: "M156.314,117.564c1.984-1.084,3.577-3.094,4.018-6.875a58.737,58.737,0,0,0-.309-9.912,32.388,32.388,0,0,0-5.65-4.621,28.324,28.324,0,0,0-7.721-3.591,4.2,4.2,0,1,1,1.926-8.182,33.918,33.918,0,0,1,7.53,3.049c-2.6-5.834-7.867-7.345-11.344-6.193a5.212,5.212,0,0,0-2.893,3.372c-1.666,3.07-3.215,14.13-3.12,19.552q1.218,2.251,2.62,4.317c.342-1.4.745-2.76,1.2-4.078.683,2.313,1.606,5.1,2.863,8.51.012.742.052,1.394.117,1.968.165,5.523,2.089,20.023,15.119,39.009a5.254,5.254,0,1,0,8.668-5.939C159.7,133.875,157.043,123.12,156.314,117.564Z",
    transform: "translate(-80.428 -46.884)",
    fill: "#f79f15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13091",
    "data-name": "Path 13091",
    d: "M155.981,91.035a3.362,3.362,0,1,0-1.535,6.547h0a29.378,29.378,0,0,1,7.979,3.7A32.777,32.777,0,0,1,174.772,115.8a3.363,3.363,0,0,0,6.155-2.712,39.543,39.543,0,0,0-15.346-17.763A34.775,34.775,0,0,0,155.981,91.035Z",
    transform: "translate(-88.024 -52.719)",
    fill: "#f79f15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13092",
    "data-name": "Path 13092",
    d: "M134.037,0,133.4,18.387l.8.214L135.731.534Z",
    transform: "translate(-77.33)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13093",
    "data-name": "Path 13093",
    d: "M150.778,10.408,140.721,25.815l.575.6,10.656-14.671Z",
    transform: "translate(-81.573 -6.033)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13094",
    "data-name": "Path 13094",
    d: "M113.181,21.05l-6.8-16.808-1.754.289,7.742,16.69Z",
    transform: "translate(-60.651 -2.459)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13095",
    "data-name": "Path 13095",
    d: "M28.313,199.988c-.346-.59-3.441.772-6.347,3.547-8.809,8.557-15.228,18.961-20.76,29.633-1.728,3.522-1.58,3.585.314.169,6.024-10.345,12.985-20.38,21.894-28.193C26.311,202.642,28.676,200.593,28.313,199.988Zm63.4,3.546c-2.905-2.775-6-4.137-6.346-3.547-.363.6,2,2.654,4.9,5.156,8.909,7.813,15.871,17.848,21.894,28.193,1.895,3.416,2.042,3.353.314-.169C106.937,222.5,100.518,212.092,91.709,203.534Z",
    transform: "translate(0 -115.85)",
    fill: "#f79f15"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoommates);
export default __webpack_public_path__ + "static/media/roommates.4922bdcb15c924dc397e6a0b999afee9.svg";
export { ForwardRef as ReactComponent };